import * as React from "react"
import { HomeFormProps } from "./home.interface"
import { Stack, Flex, Box } from "@chakra-ui/react"
import { HomeSubmitButton } from "./homeSubmitButton"
import { useRecoilValue } from "recoil"
import { brandingSelector } from "../../../recoil/atoms/room"
import { useBrowserType } from "../../../hooks/useBrowserType"
import { Input } from "./home.styled"
import { isRGBAcolor, replaceOpacity, getOpacity } from "../../../util"
import { useTranslation } from "react-i18next"
import { useLocalUserType } from "../../../hooks/useLocalUserType"

const _HomeForm: React.FC<HomeFormProps> = ({
  error,
  clearError,
  handleKeyDown,
  loading,
  joinMeeting,
  name,
  setName,
  homeInputRef,
  disabledInputField,
  isSmallContainer,
  isLandscape,
  isMobile,
  isMicCamRequired
}) => {
  const { t } = useTranslation()
  const roomStyles = useRecoilValue(brandingSelector)
  const { isAudience } = useLocalUserType()

  const handleChangeName = event => {
    setName(event.target.value)
    clearError()
  }

  const { isWindows } = useBrowserType()

  const borderColor = React.useMemo<string>(() => {
    if (error) {
      return roomStyles?.servicePanelElementWarningText ?? "red"
    }
    if (isRGBAcolor(roomStyles?.servicePanelElementBorder)) {
      return getOpacity(roomStyles?.servicePanelElementBorder) > 0.3
        ? replaceOpacity(
            roomStyles?.servicePanelElementBorder,
            getOpacity(roomStyles?.servicePanelElementBorder) - 0.3
          )
        : replaceOpacity(roomStyles?.servicePanelElementBorder, 0.1)
    }
    return `${roomStyles?.servicePanelElementBorder}b3` ?? "inherit"
  }, [
    error,
    roomStyles?.servicePanelElementBorder,
    roomStyles?.servicePanelElementWarningText
  ])

  /* const offsetTop = item.offsetTop - 15
  list.scrollTo({ top: offsetTop, behavior: "smooth" })

  const scrollToTop = () => {
    setTimeout(() => 
    window.scrollTo({
      top: item.offsetTop - 15,
      behavior: 'smooth',
    }), 1000)
  }; */

  /*  const scrollToInput = async () => {
    const rootElement = (await waitForElm("root")) as HTMLDivElement
    
    window.scrollTo({
      top: (rootElement.offsetHeight * 26) / 100,
      behavior: "smooth"
    })
  }

  React.useEffect(() => {
    const handleTouchEnd = async event => {
      if (isAudienceType) {
        let timer = setTimeout(() => {
          scrollToInput()
        }, 600)
        return () => clearTimeout(timer)
      }
    }

    const divElement = homeInputRef.current

    if (divElement) {
      divElement.addEventListener("touchend", handleTouchEnd)
    }

    return () => {
      if (divElement) {
        divElement.removeEventListener("touchend", handleTouchEnd)
      }
    }
  }, [homeInputRef, isAudienceType]) */

  const handleKeyPress = event => {
    if (event.key === "Enter" && !isMobile) {
      // Викликати вашу функцію JavaScript тут
      joinMeeting()
    }
  }

  return (
    <Stack
      maxWidth="334px"
      minW={(isSmallContainer || isLandscape) && "334px"}
      width="100%"
      margin="0 auto !important"
    >
      <Flex pos="relative" width="100%">
        {error && (
          <Box
            right="0px"
            top="-17px"
            pos="absolute"
            fontSize="0.7rem"
            fontWeight="700"
            color={roomStyles?.joinPageWarningColor ?? "red"}
          >
            {error}
          </Box>
        )}

        <Input
          type="text"
          roomStyles={roomStyles}
          error={error}
          value={name}
          id="test-input"
          name="name"
          disabled={disabledInputField}
          enterKeyHint="send"
          onChange={handleChangeName}
          onKeyPress={handleKeyPress}
          borderColor={borderColor}
          placeholder={isAudience ? t("Please enter your name") : t("Please enter a screen name")}
          ref={homeInputRef}
          /* onKeyDown={event => {
            handleKeyDown(event)
          }} */
          isWindows={isWindows}
        />
      </Flex>
      <HomeSubmitButton
        roomStyles={roomStyles}
        loading={loading}
        joinMeeting={joinMeeting}
        isMicCamRequired={isMicCamRequired}
      />
    </Stack>
  )
}

export const HomeForm = React.memo(_HomeForm)
